module.exports = __webpack_public_path__ + "fonts/fa-solid-900---7fb1cdd9c3b889161216a13267b55fe2.eot";


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/fontawesome-free/webfonts/fa-solid-900.eot
// module id = 136
// module chunks = 0